// useSeoConfig.js
import TagManager from "react-gtm-module";
import { useEffect, useRef } from "react";
import { useQuery } from "react-query";
import { SEOTAGS } from "../../util/typesReactQuery";
import { getTags } from "../../api/SEO";

const useSeoConfig = () => {
  // useRef é indispensável aqui para garantir que a inicialização aconteça uma única vez no ciclo de vida do componente
  const gtmInitialized = useRef(false);

  const { data: tags, refetch } = useQuery({
    queryKey: [SEOTAGS],
    queryFn: getTags,
    refetchOnWindowFocus: false,
    retryDelay: 3000,
    // (Crucial) Evita que o GTM seja reinicializado se o usuário perder e recuperar o foco da aba
    refetchOnReconnect: false,
  });

  // useEffect isolado para focar EXCLUSIVAMENTE na inicialização do GTM
  useEffect(() => {
    // Pega o código do GTM vindo da sua API
    const gtmCode = tags?.data?.codigoTagGlobalAnalytics;
    
    // Verifica se o código existe e se o GTM AINDA NÃO foi inicializado nesta sessão
    if (gtmCode && !gtmInitialized.current) {
      // Marca como inicializado imediatamente para evitar duplicidade
      gtmInitialized.current = true;
      
      try {
        const tagManagerArgs = {
          gtmId: gtmCode, // <- isso deve ser uma string, como já corrigimos
        };
        TagManager.initialize(tagManagerArgs);
        console.log(`✅ GTM inicializado com sucesso para o container: ${gtmCode}`);
      } catch (error) {
        console.error("❌ Falha ao inicializar o GTM:", error);
        // Se falhar, permite tentar novamente na próxima vez que o effect rodar
        gtmInitialized.current = false;
      }
    }
  }, [tags?.data?.codigoTagGlobalAnalytics]); // Executa novamente APENAS se o código da API mudar

  // --- Mantenha as funções de conversão como estão (já corrigidas) ---
  const sendTagConversionLogin = () => {
    let codeEntra = tags?.data?.codigoTagConversaoGoogleBotaoEntrar || "";
    if (!!codeEntra) {
      TagManager.dataLayer({ event: codeEntra });
    }
  };

  const sendTagConversionCadastrar = () => {
    let codeCadastrar = tags?.data?.codigoTagConversaoGoogleBotaoCadastrar || "";
    if (codeCadastrar) {
      TagManager.dataLayer({ event: codeCadastrar });
    }
  };

  const sendTagConversionFinalizar = () => {
    let codeFinalizar = tags?.data?.codigoTagConversaoPaginaCompraFinalizada || "";
    if (codeFinalizar) {
      TagManager.dataLayer({ event: codeFinalizar });
    }
  };

  const sendPageAtual = (titlePage) => {
    // Importante: use um nome de evento consistente e simples
    TagManager.dataLayer({
      event: 'pageView',
      pageTitle: titlePage,
      pagePath: window.location.pathname,
    });
  };

  return {
    sendTagConversionCadastrar,
    sendTagConversionLogin,
    sendTagConversionFinalizar,
    sendPageAtual,
  };
};

export default useSeoConfig;